<!--方案分享-->
<template>
    <div>
        <main-right-popup-common :titleName="'方案分享'" ref="mainRightPopupCommon" @loadData="loadData">
<!--            <template v-slot:typeDiv>-->
<!--                <div class="radioBox">-->
<!--                    <el-radio v-model="myLineInquiry" :label="1" @change="getListData('empty')">全部</el-radio>-->
<!--                    <el-radio v-model="myLineInquiry" :label="2" @change="getListData('empty')">有关联询单的</el-radio>-->
<!--                    <el-radio v-model="myLineInquiry" :label="3" @change="getListData('empty')">未关联询单的</el-radio>-->
<!--                    <el-radio v-model="myLineInquiry" :label="4" @change="getListData('empty')">有订单的</el-radio>-->
<!--                    <el-radio v-model="myLineInquiry" :label="5" @change="getListData('empty')">采用定制师的</el-radio>-->
<!--                    <el-radio v-model="myLineInquiry" :label="6" @change="getListData('empty')">定制师分享给我</el-radio>-->
<!--                </div>-->
<!--            </template>-->
            <template v-slot:searchDiv>
                <div class="searchDiv" v-show="myLineInquiry!=2">
                    <div class="firstLineSearch">
                        <el-select v-model="dateValue" placeholder="请选择" size="mini" style="margin-right: 0.05rem;width: 1rem;">
                            <el-option label="制作日期" :value="1"></el-option>
                            <el-option label="出发日期" :value="2"></el-option>
                        </el-select>
                        <el-date-picker type="daterange" size="mini" style="width: 2.15rem" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" v-model="dateArr" value-format="yyyy-MM-dd"></el-date-picker>
                        <span style="font-size: 14px; color: #101010; margin-left: 0.2rem">今日</span>
                        <span style="font-size: 14px; color: #101010; margin-left: 0.1rem">本周</span>
                        <span style="font-size: 14px; color: #101010; margin-left: 0.1rem">本月</span>
                        <span style="font-size: 14px; color: #101010; margin-left: 0.1rem">近两个月</span>
                    </div>
                    <div style="margin-top: 10px" class="firstLineSearch">
                        <span class="boldFont">目的地&nbsp;</span>
                        <el-input style="width: 1.48rem" v-model="destination" size="mini" />
                        <span class="boldFont" style="    margin-left: 0.1rem;">行程名称&nbsp;</span>
                        <el-input style="width: 1.48rem" v-model="budgetName" size="mini" />
                        <el-select v-model="sortType" placeholder="请选择" size="mini" @change="getListData('empty')" style="margin-left: 0.05rem;width: 1rem;">
                            <el-option label="按修改日期倒序" :value="1"></el-option>
                            <el-option label="按出发日期倒序" :value="2"></el-option>
                            <el-option label="按出发日期正序" :value="3"></el-option>
                        </el-select>
                        <button class="createBtn" size="mini" type="primary" style="margin-left: 0.35rem" @click="createPlan">创建行程</button>
                        <!-- <div class="administrator_box" v-if="$store.state.userInfor.userName === 'admin'">
                          制作人：
                          <el-autocomplete v-model="producer" :clearable="true" @clear="clearProducer" :popper-append-to-body="false" size="mini"
                            style="width: 120px"
                            :fetch-suggestions="querySearchAsyncProducer"
                            @select="handleSelectProducer"
                            placeholder="请选择"></el-autocomplete>
                        </div> -->
                    </div>
                    <div style="margin-top: 10px">
                        <el-input style="width: 2.1rem" size="mini" v-model="keyword" placeholder="客户名称/团号/询单号/生成人"/>
                        <span style="margin-left: 0.1rem;font-weight: bold;">天数&nbsp;</span>
                        <el-input style="width: 0.66rem" size="mini" />
                        <span style="margin-left: 0.1rem;font-weight: bold;">人数</span>
                        <el-input style="width: 0.69rem" size="mini" />
                        <span class="searchTravel" @click="getListData('empty')">搜索</span>
                    </div>
                </div>
                <div v-show="myLineInquiry==2">
                    <div class="firstLineSearch">
                        <span class="boldFont">询单号&nbsp;</span>
                        <el-input style="width: 1.48rem" v-model="inquiryNumber" size="mini" />
                    </div>
                    <div style="margin-top: 10px" class="firstLineSearch">
                        <span class="boldFont">目的地&nbsp;</span>
                        <el-input style="width: 1.48rem" v-model="destination" size="mini" />
                    </div>
                    <div style="margin-top: 10px">
                        <el-input style="width: 2.1rem" size="mini" v-model="keyword" placeholder="客户名称/团号/询单号/生成人"/>
                        <span style="margin-left: 0.1rem;font-weight: bold;">天数&nbsp;</span>
                        <el-input style="width: 0.66rem" size="mini" />
                        <span style="margin-left: 0.1rem;font-weight: bold;">人数</span>
                        <el-input style="width: 0.69rem" size="mini" />
                        <span class="searchTravel" @click="getListData('empty')">搜索</span>
                    </div>
                </div>
            </template>
            <template v-slot:dataDiv>
                <div v-show="myLineInquiry!=2">
                    <div v-for="(item,index) in informationList" :key="index">
                        <plan-list-info :item="item" :planId="planId" @replaceStroke="replaceStroke" @delPlan="delPlan" :index="index"
                                        @copyPlan="copyPlan" @goXunList="goXunList" :showInquiryButton="true"></plan-list-info>
                    </div>
                </div>
                <div v-show="myLineInquiry==2">
                    <template v-for="(item, index) in myProgramData">
                        <div class="makeByInquiry" :key="index">
                            <div class="head">
                                <div class="head_left">
                                    <div class="title">
                                        <div class="planName">
                                            <span v-for="(itemTwo, indexTwo) in item.destination" :key="indexTwo" :style="`margin-left:${indexTwo == 0 ? '0' : '5'}px;`">{{ itemTwo.cityName }}</span>
                                        </div>
                                        <div class="planName" style="margin-left: 10px">
                                            {{item.inquiryMaintainList[0].estimatedTravelEnd === "" ? "" : (item.inquiryMaintainList[0].estimatedTravelEnd -item.inquiryMaintainList[0].estimatedTravelStart) /86400000 +1 +"天"}}
                                            {{new Date(item.inquiryMaintainList[0].estimatedTravelStart).getMonth() +1 +"." + new Date(item.inquiryMaintainList[0].estimatedTravelStart).getDate() }}
                                        </div>
                                    </div>
                                    <div>
                    <span style="font-size: 14px;color: rgba(19, 144, 202, 100);display: inline-block;width: 122px;">
                      询单号：{{ item.id }}
                    </span>
                                        <span style="font-size: 12px; color: #101010; margin-left: 40px">
                      {{ dateFormatYMDHM(item.inquiryMaintainList[0].grabbingTime, "-") }}
                      {{ item.inquiryMaintainList[0].customizerName }}抢单成功
                    </span>
                                    </div>
                                    <div style="font-size: 14px; color: #101010; margin-top: 5px">
                    <span style="display: inline-block;width: 95px;height: 21px;border: 1px solid #1b94cc;border-radius: 4px;
                      text-align: center;line-height: 19px;color: #1b94cc;margin-left: 20px;" v-if="item.inquiryMaintainList[0].isSend==0">尚未发送方案</span>
                                        <span style="display: inline-block;width: 95px;height: 21px;border: 1px solid #db4e1a;border-radius: 4px;
                      text-align: center;line-height: 19px;color: #db4e1a;margin-left: 20px;" v-if="item.inquiryMaintainList[0].isSend==1">已发送方案</span>
                                    </div>
                                    <div style="display: flex; margin-top: 5px">
                                        <div style=" color: #1b94cc;display: flex;align-items: center;width: 160px;">
                                            <span style="cursor: pointer" @click.stop="(item.isShowMore = true), (item.isShowMoreTwo = false)">询单详情</span>
                                            <i class="el-icon-arrow-down" style="font-size: 18px;margin-left: 10px;cursor: pointer;"
                                               @click="(item.isShowMore = true), (item.isShowMoreTwo = false)"></i>
                                        </div>
                                        <div style="color: #e65019; display: flex;align-items: center; width: 160px;">
                                            <span style="cursor: pointer" @click.stop="showProgramDetails(item)">方案详情</span>
                                            <i class="el-icon-arrow-down" style="font-size: 18px;margin-left: 10px;cursor: pointer;" @click.stop="showProgramDetails(item)"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="head_right">
                                    <div class="right_head" @click.stop="goCopy(item)">
                                        <!-- 去行程库复制方案 -->
                                    </div>
                                    <div class="right_center">
                                        <!-- <div style="position: relative">
                                          <div class="avatar" :style="`z-index:${100 - indexUrl};left:${10 * indexUrl}px;`"
                                            v-for="(itemUrl, indexUrl) in item.imageUrls" :key="indexUrl">
                                            <img :src="itemUrl" width="100%" height="100%" style="border-radius: 50%"/>
                                          </div>
                                        </div>
                                        <div  style="width: 34px;height: 34px; background: #eca388; color: white;cursor: pointer;text-align: center;
                                          line-height: 17px; ">
                                          查看<br />客户
                                        </div> -->
                                    </div>
                                    <div class="right_footer" @click.stop="makeStroke(item)">
                                        制作行程
                                    </div>
                                </div>
                            </div>
                            <div :class="item.isShowMore ? 'body' : 'body_hidden body'">
                                <div style="padding: 10px;border-bottom: 1px solid #ddd;padding-left: 20px;display: flex;">
                  <span style="display: inline-block; width: 50px; height: 20px; border-radius: 5px; text-align: center;
                    line-height: 20px;background: #eb7549; color: white;margin-left: 10px;">
                    {{item.type == 1 ? "私家团" : "企业团"}}</span>
                                    <span style="font-size: 14px; color: #101010; margin-left: 30px">和客户沟通后信息更新：</span>
                                </div>
                                <div style="padding: 10px;padding-left: 20px;padding-bottom: 0;font-size: 12px;color: #101010;">
                                    <div style="display: flex; align-items: center">
                                        <span class="body_title">公司名称：</span>
                                        <span style="display: inline-block;width: 130px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                              :title="item.createCompanyName">{{ item.createCompanyName }}</span>
                                        <span style="font-weight: bold;color: #e65019;margin-left: 17px;">客户名称：{{ item.createName }}</span>
                                    </div>
                                    <div style="margin-top: 10px">
                                        <span class="body_title">客户Email：</span>
                                        <span style="display: inline-block; width: 130px">{{item.email}}</span>
                                        <span style="font-weight: bold;color: #e65019;margin-left: 10px;">客户电话：{{ item.telephone}}</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">目的地: </span>
                                        <span v-for="(itemTwo, indexTwo) in item.destination" :key="indexTwo" :style="`margin-left:${indexTwo == 0 ? '0' : '10'}px;`">{{ itemTwo.cityName }}</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">预估出行日期: </span>
                                        <span>
                      {{ dateFormatYMD(item.inquiryMaintainList[0].estimatedTravelStart, "/") }}
                      <span v-if="item.inquiryMaintainList[0].estimatedTravelEnd !== ''">至</span>
                      {{item.inquiryMaintainList[0].estimatedTravelEnd === ""? "": dateFormatYMD(item.inquiryMaintainList[0].estimatedTravelEnd, "/")}}
                      {{item.inquiryMaintainList[0].estimatedTravelEnd === ""? "": (item.inquiryMaintainList[0].estimatedTravelEnd -item.inquiryMaintainList[0].estimatedTravelStart) /86400000 +1 + "天"}}
                    </span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">预估出行人数: </span>
                                        <span>
                      {{ item.inquiryMaintainList[0].estimatedTravelAdultNum }}成人
                      {{item.inquiryMaintainList[0].estimatedTravelAdultChildren}}儿童
                    </span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">预算：</span>
                                        <span>{{ item.inquiryMaintainList[0].price }} /人</span>
                                        <span>{{item.inquiryMaintainList[0].type == 0? "不含机票": item.inquiryMaintainList[0].type == 1? "含经济舱": "含公/头等舱"}}&nbsp;</span>
                                        <span v-if="item.departurePlace&&item.departurePlace != ''">{{ item.departurePlace.cityName }}出发</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">主题：</span>
                                        <span v-for="(itemTwo, indexTwo) in item.theme" :key="indexTwo" :style="`margin-left:${indexTwo == 0 ? '0' : '10'}px;`">{{ itemTwo }}</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">行程期待：</span>
                                        <span v-for="(itemTwo, indexTwo) in item.planExpect" :key="indexTwo" :style="`margin-left:${indexTwo == 0 ? '0' : '10'}px;`">{{ itemTwo }}</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">所需服务：</span>
                                        <span v-for="(itemTwo, indexTwo) in item.needService" :key="indexTwo" :style="`margin-left:${indexTwo == 0 ? '0' : '10'}px;`">{{ itemTwo }}</span>
                                    </div>
                                    <div class="body_items">
                                        <span class="body_title">客户留言：</span>
                                        <span>{{ item.inquiryMaintainList[0].customerMessage }}</span>
                                    </div>
                                </div>
                                <div style="text-align: right">
                                    <i class="el-icon-caret-top" style="font-size: 24px; cursor: pointer" @click.stop="item.isShowMore = false"></i>
                                </div>
                            </div>
                            <div style="padding: 0 15px; padding-top: 20px" :class="item.isShowMoreTwo ? 'body' : 'body_hidden body'" v-if="item.isShowMoreTwo">
                                <div class="customize_box" v-for="(itemThree, indexThree) in item.programList" :key="indexThree" style="margin: 0; margin-bottom: 15px">
                                    <plan-list-info :item="itemThree" :planId="planId" @replaceStroke="replaceStroke($event,item)"
                                                    @delPlan="delPlan" :index="index" @copyPlan="copyPlan"></plan-list-info>
                                </div>
                                <div style="text-align: right">
                                    <i class="el-icon-caret-top" style="font-size: 24px; cursor: pointer" @click="item.isShowMoreTwo=false"></i>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </main-right-popup-common>
        <create-plan ref="createPlan"></create-plan>
    </div>
</template>

<script>
import mainRightPopupCommon from '../mainRightPopupCommon.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import {mapState} from "vuex"
import { getPlanInfo } from '../../js/function'
import PlanListInfo from './child/planListInfo.vue'
import CreatePlan from '../../leftMoudle/dialog/createPlan.vue'
import Api from '@/components/Api/index.js'
export default {
    components: {mainRightPopupCommon,PlanListInfo,CreatePlan },
    computed:{
        ...mapState(['planId','rightPopupIndexType']),
    },
    data(){
        return{
            informationProductPage:1,
            informationList:[],
            destination:null,
            keyword:null,
            myLineInquiry:1,
            myProgramData:[],
            inquiryNumber:null,
            budgetName:null,
            dateValue:1,
            dateArr:[],
            sortType:1,
        }
    },

    methods:{
        loadData(){
            this.informationProductPage++;
            this.getListData()
        },
        goXunList(item){
            this.myLineInquiry = 2
            this.inquiryNumber= item.inquiries.map(ee=>ee.inquiryId).join(",")
            this.getListData('empty')
        },
        handlePlanList(res){
            res.data.records.forEach(element => {
                this.$set(element,'showIndex',0)
                element.budgetMains.forEach(item=>{
                    var str = item.planName.split(' ')
                    if(str.length==1){
                        this.$set(item,'planName','')
                        this.$set(item,'planName1',str[0])
                    }else{
                        var planName=""
                        str.forEach((item1,index)=>{
                            if(index!=str.length-1){
                                planName+=item1+" "
                            }
                        })
                        this.$set(item,'planName',planName)
                        this.$set(item,'planName1',str[str.length-1])
                    }
                })
            });
        },
        getListData(type){
            this.$store.commit('setRightPopupIndexType',this.myLineInquiry)
            this.$refs.mainRightPopupCommon.loading = true
            if(this.myLineInquiry==2){
                if(type=='empty'){
                    this.informationProductPage = 1;
                    this.myProgramData = []
                    this.$refs.mainRightPopupCommon.isMore = false;
                }
                new Api('inquiry').grabbingInquiryList({
                    page:this.informationProductPage,
                    size:10,
                    q:{
                        ids:this.inquiryNumber?this.inquiryNumber.split(","):[]
                    }
                }).then(res => {
                    this.$set(this.$refs.mainRightPopupCommon,'loading',false)
                    if (res.status == 200) {
                        res.data.records.forEach((ee,index)=>{
                            this.$set(ee,'isShowMore',false)
                            if(index==0) this.$set(ee,'isShowMore',true)
                            this.$set(ee,'isShowMoreTwo',false)
                            this.$set(ee,'destination',JSON.parse(ee.inquiryMaintainList[0].destination))
                            this.$set(ee,'theme',JSON.parse(ee.inquiryMaintainList[0].theme))
                            this.$set(ee,'planExpect',JSON.parse(ee.inquiryMaintainList[0].planExpect))
                            this.$set(ee,'needService',JSON.parse(ee.inquiryMaintainList[0].needService))
                            if(ee.inquiryMaintainList[0].departurePlace&&ee.inquiryMaintainList[0].departurePlace!=''){
                                this.$set(ee,'departurePlace',JSON.parse(ee.inquiryMaintainList[0].departurePlace))
                            }
                        })
                        this.myProgramData = [...this.myProgramData,...res.data.records]
                        if(res.data.records.length<10){
                            this.$refs.mainRightPopupCommon.isMore = true
                        }
                    }else{
                        this.$message({type:"error",message:res.statusText})
                    }
                })
            }else{
                if(type=='empty'){
                    this.informationProductPage = 1;
                    this.informationList = []
                    this.$refs.mainRightPopupCommon.isMore = false;
                }
                new PlanApi('plan').planSharList({
                    page:this.informationProductPage,
                    size:10,
                    q:{
                        destination:this.destination,
                        keyword:this.keyword,
                        budgetName:this.budgetName,
                        timeType:this.dateValue,
                        startDate:this.dateArr&&this.dateArr.length>0?this.dateArr[0]:null,
                        endDate:this.dateArr&&this.dateArr.length>0?this.dateArr[1]:null,
                        sortType:this.sortType
                    }
                }).then(res => {
                    this.$set(this.$refs.mainRightPopupCommon,'loading',false)
                    if (res.status == 200) {
                        if(!this.$store.state.planId&&res.data.records.length>0){
                            this.$store.commit('setPlanId', res.data.records[0].id)
                            getPlanInfo(res.data.records[0].id,null)
                        }
                        this.handlePlanList(res)
                        this.informationList = [...this.informationList,...res.data.records]
                        if(res.data.records.length<10){
                            this.$refs.mainRightPopupCommon.isMore = true
                        }
                    }else{
                        this.$message({type:"error",message:res.statusText})
                    }
                })
            }
        },
        replaceStroke(item,name){//替换左边行程轴
            var itemThree = item.budgetMain
            this.$store.commit('setPlanId', item.id)
            this.$store.commit('setBudgetMainId', itemThree.id)
            getPlanInfo(this.$store.state.planId,this.$store.state.budgetMainId)
            if(name=='share'){
                this.$Bus.$emit("sharePlan");
            }
        },
        createPlan(){
            this.$refs.createPlan.showCreatePlanType = true
            this.$refs.createPlan.showPlanDay =true
            this.$refs.createPlan.showEndTripDate = true
            this.$refs.createPlan.oldPlanObj={}
            this.$refs.createPlan.beforOpen()
        },
        makeStroke(item){
            this.$refs.createPlan.creatTripDate = this.dateFormatYMD(item.inquiryMaintainList[0].estimatedTravelStart,"-")
            this.$refs.createPlan.useNumber =item.inquiryMaintainList[0].estimatedTravelAdultNum
            this.$refs.createPlan.isUser =item.isUser
            this.$refs.createPlan.endTripDate =this.dateFormatYMD(item.inquiryMaintainList[0].estimatedTravelEnd,"-")
            this.$refs.createPlan.creatTripDays = Number(this.getBetweenDay([this.$refs.createPlan.creatTripDate,this.$refs.createPlan.endTripDate])+1)
            this.$refs.createPlan.beforOpen(item.id)
        },
        delPlan(item){
            this.$confirm('您确定要删除所有方案吗？点击确认将删除草稿内的所有方案', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new PlanApi('plan').delPlan({planId:item.id,budgetMainId:null}).then(res => {
                    if (res.status == 200) {
                        this.$message({type:"success",message:"删除成功"})
                        if(item.id==this.planId){
                            this.$store.commit('setPlanId', null)
                        }
                        this.getListData('empty')
                    }else{
                        this.$message({type:"error",message:res.statusText})
                    }
                })
            }).catch((err) => {})
        },
        copyPlan(item){
            this.$refs.createPlan.creatTripDate = this.dateFormatYMD(item.budgetMains[item.showIndex].departureDate,"-")
            this.$refs.createPlan.useNumber =item.budgetMains[item.showIndex].useNumber
            this.$refs.createPlan.creatTripDays =item.budgetMains[item.showIndex].planDay
            this.$refs.createPlan.showCreatePlanType = false
            this.$refs.createPlan.showPlanDay =false
            this.$refs.createPlan.showEndTripDate = false
            this.$refs.createPlan.oldPlanObj = {
                id:item.budgetMains[item.showIndex].id
            }
            this.$refs.createPlan.beforOpen()
        },
        showProgramDetails(item) {
            (item.isShowMore = false), (item.isShowMoreTwo = true);
            new PlanApi('plan').planList({page:1,size:10,q:{informationId:item.id}}).then(res => {
                if (res.status == 200) {
                    this.handlePlanList(res)
                    this.$set(item, "programList", res.data.records);
                }else{
                    this.$message({type:"error",message:res.statusText})
                }
            })
        },
    },
    watch:{
        "rightPopupIndexType":{
            handler(){
                this.myLineInquiry = this.rightPopupIndexType
            },deep:true
        }
    },
    mounted(){
        this.myLineInquiry = this.rightPopupIndexType
        this.getListData('empty')
    }
}
</script>

<style lang="scss" scoped>
.radioBox{
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    width: 7rem;
    padding-left: 0.08rem;

    /deep/ .el-radio__label{
        padding-left: 0;
        font-size: 0.14rem;
    }
    /deep/ .el-radio{
        margin-right: 0.03rem;
    }
}
.searchDiv{
    .firstLineSearch{
        font-size: 0.12rem;
        /deep/ .el-range-separator{
            transform: translateX(-4px);
        }
        button{
            height: 0.28rem;
            color: #fff;
            background: var(--buttonColor);
            font-weight: bold;
            border-radius: 4px;
            padding: 0 0.1rem;
            border: none;
        }
    }
}
.searchTravel {
    display: inline-block;
    height: 0.28rem;
    line-height: 0.28rem;
    margin-left: 0.2rem;
    text-shadow: 2px 2px 5px #999;
    color: #f54402;
    font-weight: bold;
    cursor: pointer;
}
.makeByInquiry{
    border-radius: 15px 15px 0px 0px;
    background:white;
    box-shadow: 2px 5px 10px 3px rgba(0, 0, 0 ,0.2);
    margin-top:20px;
    .head{
        display:flex;
        justify-content:space-between;
        border-bottom:3px solid #DB4E1A;
        .head_left{
            position:relative;
            padding:20px 10px 10px 20px;
            .title{
                position:absolute;
                top: -10px;
                display:flex;
                .planName{
                    max-width:100px;
                    padding:0 5px;
                    border-radius:4px;
                    color:white;
                    background:#EC8192;
                    height:26px;
                    line-height:26px;
                    text-align:center;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                }
            }
        }
        .head_right{
            display:flex;
            justify-content:space-between;
            flex-direction:column;
            .right_head{
                width: 122px;
                height: 27px;
                line-height:27px;
                border-top-right-radius:15px;
                background:#DD5963;
                color:white;
                text-align:center;
                cursor:pointer;
            }
            .right_center{
                display:flex;
                justify-content:space-between;
                .avatar{
                    position:absolute;
                    top:0;
                    width:30px;
                    height:30px;
                    border-radius:50%;
                    border:2px solid white;
                }
            }
            .right_footer{
                width:123px;
                height:27px;
                background:#DB4E1A;
                color:white;
                text-align:center;
                line-height:27px;
                cursor:pointer;
            }
        }
    }
    .body{
        background:white;
        max-height:1000px;
        transition: all ease 0.5s;
        .body_items{
            margin-top:10px;
        }
        .body_title{
            font-weight:bold;
            display:inline-block;
            width:100px;
        }
    }
    .body_hidden{
        max-height:0;
        overflow: hidden;
    }
}
</style>